import { Link } from "react-router-dom";
import { latestArticles } from "@/mocks/articles";

export default function ArticleSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            最新资讯
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            电影行业动态与深度解析
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group cursor-pointer rounded-xl overflow-hidden bg-background-100 hover:bg-background-200/70 transition-colors"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={`${article.title} - 555电影网`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-3 mb-2">
                  <span className="text-xs bg-secondary-100 text-secondary-900 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    {article.date}
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/article/article-2"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors font-medium cursor-pointer whitespace-nowrap"
          >
            查看更多资讯
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}